/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './declaration.defs.js'
export * as $defs from './declaration.defs.js'
